'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = LayoutBoundary;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Layout Boundary Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function LayoutBoundary(props) {
    var width = props.width,
        height = props.height,
        overflow = props.overflow,
        id = props.id;


    var style = {
        width: width,
        height: height,
        overflow: overflow
    };

    return (0, _jsx3.default)('div', {
        id: id,
        style: style
    }, void 0, props.children);
}
//# sourceMappingURL=LayoutBoundary.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/layoutBoundary/LayoutBoundary.js
// module id = 566
// module chunks = 0